// Evaluates checks[] → { isInvalid, errorMessages }

import type { CheckRule } from '../types/A2UICommon.types.tsx';

import { resolveDynamicBoolean, type ResolverContext } from './dynamicResolver.ts';

export type ValidationResult = {
	errorMessages: string[];
	isInvalid: boolean;
};

export function evaluateChecks(
	checks: CheckRule[] | undefined,
	context: ResolverContext,
): ValidationResult {
	if (!checks || checks.length === 0) {
		return { isInvalid: false, errorMessages: [] };
	}

	const errorMessages: string[] = [];
	for (const check of checks) {
		const conditionMet = resolveDynamicBoolean(check.condition, context);
		// In A2UI, condition resolves to true when valid, false when invalid
		if (!conditionMet) {
			errorMessages.push(check.message);
		}
	}

	return {
		isInvalid: errorMessages.length > 0,
		errorMessages,
	};
}
